import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { usePortfolio } from "@/context/PortfolioContext";

export function SubPortfolioSelect({ value, onChange, includeAll = true, testId = "sub-portfolio-select" }) {
    const { subs } = usePortfolio();
    return (
        <Select value={value} onValueChange={onChange}>
            <SelectTrigger className="w-[180px] num" data-testid={testId}>
                <SelectValue placeholder="Sub-portfolio" />
            </SelectTrigger>
            <SelectContent>
                {includeAll && <SelectItem value="ALL">All Sub-portfolios</SelectItem>}
                {subs.map((s) => <SelectItem key={s.id} value={s.name}>{s.name}</SelectItem>)}
            </SelectContent>
        </Select>
    );
}
